import PlaceType from '../../types/Place';

import { PlaceAction } from './types';

const placeReducer = (state: PlaceType, action: PlaceAction) => {
	switch (action.type) {
		case 'update-place': {
			return { ...state, ...action.place };
		}
	}
	return state;
};

export default placeReducer;
